(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LastName', LastName);

    LastName.$inject = ['$resource'];

    function LastName ($resource) {
        var resourceUrl =  'api/last-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
